
import { createReducer } from '../utils/misc';
import {
    ADMIN_DRAWER
} from '../constants/index';

const initialState = {
    currentView: 'clients'
};

export default createReducer(initialState, {
    [ADMIN_DRAWER]: (state, payload) =>
        Object.assign({}, state, {
            currentView: payload.view,
        }),
    })


// WEBPACK FOOTER //
// ./src/reducers/admin.js